import { render, staticRenderFns } from "./CreateCampaignDialogComponent.vue?vue&type=template&id=a390756e&"
import script from "./CreateCampaignDialogComponent.vue?vue&type=script&lang=js&"
export * from "./CreateCampaignDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports